import React, {useState, useEffect, useRef} from "react";
import PortableText from "./portableText";
import sanityClient from "@sanity/client";
import clientConfig from "../../client-config";
import * as styles from './blogList.module.css';
import { buildImageObj, cn, getBlogUrl } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

function BlogList(props) {

    const client = sanityClient(clientConfig.sanity);
    const [posts, setPosts] = useState([]);
    const [categories, setCategory] = useState([]);
    const sectionRef = useRef();
    const listRef = useRef();
    
    useEffect(() => {
        client
        .fetch(
            `*[_type == "category"] | order(sortorder desc) {
            _id,
            title,
            "posts": *[_type == "post" && references(^._id)]{
                title,
                excerpt,
                slug,
                mainImage
            }
        }`
        )
        .then((data) => setCategory(data))
        .catch(console.error)
    }, []);

    useEffect(() => {
        client
        .fetch(
            `*[_type == "post"] | order(priority desc, publishedAt desc){
                title,
                excerpt,
                slug,
                mainImage,
                priority,
                categories
            }`
        )
        .then((data) => setPosts(data))
        .catch(console.error)
    }, []);

    function toggleTab(key, label){
        $(listRef.current).find('.tabMobileValue span').text(label);
        $(listRef.current).find('.tabMobileValue').attr('data-value', key);
        $(listRef.current).find('.tabLabel').removeClass(styles.tabLabel__active);
        $(listRef.current).find('.tabLabel[data-id="'+key+'"]').addClass(styles.tabLabel__active);
        $(listRef.current).find('.tabOptions').slideUp(200);
        $(listRef.current).find('.filterItem').hide();
        $(listRef.current).find('.filterItem').each(function(){
            let catIds = $(this).attr('data-cat');
            
            if(catIds.includes(key)){
                $(this).fadeIn(250);
            }

        });
    }

    function toggleOptions(){
        $(listRef.current).find('.tabOptions').slideToggle(200).toggleClass(styles.mobileTabOptions__active);
    }

    if(posts.length){

        let iconClass = 'fas fa-chevron-down';
        let tabOptionValueClass = styles.mobileTabValue + ' tabMobileValue';
        let tabOptionsClass = styles.mobileTabOptions + ' tabOptions';
        let tabLabelClass = styles.tabLabel + ' tabLabel';
        let initialTabLabelClass = styles.tabLabel + ' ' + styles.tabLabel__active + ' tabLabel';
        let itemClass = styles.itemWrap + ' filterItem';
        
        return (
            <div className={styles.blogList} ref={sectionRef}>
                <div className={styles.sectionContainer}>
                    <h1>{props.heading}</h1>
                    <div className={styles.richtext}>
                        <PortableText blocks={props.content} />
                    </div>
                    <div className={styles.tabWrapper} ref={listRef}>

                        <div className={styles.tabLabelWrap}>
                            <div className={initialTabLabelClass} onClick={ () => toggleTab('all', 'All') } data-id="all">
                                All
                            </div>
                            {
                                categories.map((item, i) => {
                                    return (
                                        <div className={tabLabelClass} data-id={item._id} key={i} onClick={ () => toggleTab(item._id, item.title) }>
                                            {item.title}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={styles.mobileTabSelect}>
                            <div className={tabOptionValueClass} data-value="all" onClick={ () => toggleOptions() }>
                                <span>View All</span>
                                <i className={iconClass}></i> 
                            </div>
                            <div className={tabOptionsClass}>
                                <div className={styles.tabOption} onClick={ () => toggleTab('all', 'View All') }>
                                    View All
                                </div>
                                {
                                    categories.map((item, i) => {
                                        return (
                                            <div className={styles.tabOption} key={i} onClick={ () => toggleTab(item._id, item.title) }>
                                                { item.title }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>

                        <div className={styles.listWrapper}>

                            {
                                posts.map((item, i) => { 

                                    let post_url = getBlogUrl(item.slug.current);
                                    let post_image = '';
                                    item.key = 'pkey-'+i;

                                    if(item.mainImage){
                                        post_image = (item.mainImage.asset) ? imageUrlFor(buildImageObj(item.mainImage)) : '';
                                    }

                                    if(item.slug){

                                        let catIds = 'all';

                                        if(item.categories.length){
                                            for(let ci = 0; ci < item.categories.length; ci++){
                                                if(item.categories[ci]){
                                                    catIds += '|'+item.categories[ci]._ref;
                                                }
                                            }
                                        }
                                        
                                        return (
                                            <a href={post_url} className={itemClass} key={i} data-cat={catIds}>
                                                <div className={styles.imageWrap}>
                                                    <img src={post_image} alt={item.title} />
                                                </div>
                                                <div className={styles.contentTextWrap}>
                                                    <div className={styles.contentTitle}>
                                                        {item.title}
                                                    </div>
                                                    <div className={styles.description}>
                                                        <PortableText blocks={item.excerpt} />
                                                    </div>
                                                </div>
                                            </a>
                                        )
                                    }
                                })
                            }

                        </div>

                    </div>
                </div>
            </div>
        );

    } else {
        return (
            <div className={styles.blogList}>
                <div className={styles.sectionContainer}>
                    <h1>{props.heading}</h1>
                    <h5>Loading articles, please wait...</h5>
                </div>
            </div>
        );
    }
}

export default BlogList;
